import { render, staticRenderFns } from "./VideosWidget.vue?vue&type=template&id=131b5a6a&"
import script from "./VideosWidget.vue?vue&type=script&lang=js&"
export * from "./VideosWidget.vue?vue&type=script&lang=js&"
import style0 from "./VideosWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports